import type { ComponentProps } from 'react';
import { MarketInputText } from '@market/react';
import type { MarketInputTextCustomEvent } from '@market/web-components';
import * as React from 'react';

export type MarketInputProps = Omit<ComponentProps<typeof MarketInputText>, 'onMarketInputValueChange' | 'onChange'> & {
  label?: string;
  onChange(e: MarketInputTextCustomEvent<{ value: string; originalEvent: KeyboardEvent }>): void;
};

export const MarketInput: React.FC<React.PropsWithChildren<MarketInputProps>> = ({ label = '', onChange, disabled, children, ...props }) => (
  <MarketInputText {...props} onMarketInputValueChange={onChange} disabled={disabled || undefined}>
    <label>{label}</label>
    {children}
  </MarketInputText>
);
